// src/pages/SubscriptionCallback.jsx
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import paymentService from '../services/paymentService';
import { useUser } from '../context/UserContext';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const SubscriptionCallback = () => {
  const query = useQuery();
  const reference = query.get('reference');
  const [status, setStatus] = useState('Verifying...');
  const navigate = useNavigate();

  const { refreshUser } = useUser();

  useEffect(() => {
    const verify = async () => {
      try {
        if (!reference) {
          setStatus('No reference provided');
          return;
        }
        const res = await paymentService.verify(reference);
        if (res?.status === 'success') {
          setStatus('Payment verified. Your account has been upgraded.');
          // Refresh user context and redirect to dashboard
          try {
            await refreshUser();
          } catch (e) {
            // Ignore refresh errors
          }
          setTimeout(() => navigate('/dashboard'), 1200);
        } else {
          setStatus('Verification failed. We received the payment info and will update your account shortly.');
        }
      } catch (err) {
        console.error(err);
        setStatus('Verification error. Please contact support.');
      }
    };

    verify();
  }, [reference, navigate, refreshUser]);

  return (
    <div>
      <Header />
      <main className="max-w-3xl mx-auto p-8 text-center">
        <h1 className="text-2xl font-bold mb-4">Subscription Status</h1>
        <p>{status}</p>
      </main>
      <Footer />
    </div>
  );
};

export default SubscriptionCallback;